import React from "react";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import './returns.scss';
import Button from '@material-ui/core/Button';
import AttachmentIcon from '@material-ui/icons/Attachment';
import UploadIcon from '@material-ui/icons/CloudUpload';
import CloseIcon from '@material-ui/icons/Close';
import CancelIcon from '@material-ui/icons/Cancel';
import ReturnsSrv from "../../services/returns_srv";
import PropTypes from "prop-types";
import moment from 'moment'




class Returns extends React.Component{

    returnsSrv;

    constructor(props){
        super(props);
        
            this.state = {
                return:null,
                sn:'',
                snerror:false,
                isProductLoaded:false,
                failure:{ id:'', name:''}, 
                diagnosis:{id:'', name :''},
                error:null,
                isDiagnosisLoaded:false,
                diagnosisList: null,
                failuresList:null,
                selectedFile:null,
                files: null,
                valid:true

            };
            this.returnsSrv= new ReturnsSrv(this.props.auth);
            this.getProductByUserProductId = this.getProductByUserProductId.bind(this);
            this.getDiagnosisList = this.getDiagnosisList.bind(this);
            this.getAllFiles = this.getAllFiles.bind(this);
            this.addFile = this.addFile.bind(this);
            this.deleteFile = this.deleteFile.bind(this);
            
            this.handleChangeFailure = this.handleChangeFailure.bind(this);
            this.handleChangeDiagnosis =  this.handleChangeDiagnosis.bind(this);
            this.hanleChangeSN = this.handleChangeSN.bind(this);
            this.keyPress = this.keyPress.bind(this);
            this.loadDropDowns = this.loadDropDowns.bind(this);
            this.closeTicketHandler = this.closeTicketHandler.bind(this);
            this.displayDiagnosisList =  this.displayDiagnosisList.bind(this);
    }


    render(){
        return <Container className='psr-container'>
                <Row>
                    <Col className='header' >Article Diagnostics </Col>
                </Row>
                <Row ><div className='text'>Please Scan Article or Enter the Article ID Manually Below:</div></Row>
                <Row>
                    <TextField className='search'
                            error ={this.state.snerror}
                            id="outlined-search"
                            label= { !this.state.snerror ? "Serial Number": "INVALID Entry"}
                            type="search"
                            margin="normal"
                            variant="outlined"
                            value={this.state.sn}
                            onKeyDown={this.keyPress}
                            onChange={(e) => this.handleChangeSN(e)}
                    />
                </Row>
                <Row>
                    {/* <span>Please Enter the Fields Below</span> */}
                </Row>
                <Container className={!this.state.return?'article-fields-container':'article-fields-container show'}>
                <Row>
                    <Col className='column ' xs={12} lg={6}>

                    
                        <TextField
                            className='read-only'
                            id="outlined-search"
                            label="Product Type"
                            type="search"
                            variant="outlined"
                            value={this.state.return?this.state.return.product.productType.name:''}
                            InputProps={{
            readOnly: true,
            }}
                        />
                        

                
                        <TextField
                            className='read-only'
                            id="outlined-search"
                            label="Hardware Version"
                            type="search"
                            variant="outlined"
                            value={this.state.return?(this.state.return.product.hardwareVersion?this.state.return.product.hardwareVersion:'N/A'):''}
                            InputProps={{
            readOnly: true,
            }}
                        />
                
        
                        <TextField
                            className='read-only'
                            id="outlined-search"
                            label="Firmware Version"
                            type="search"
                            variant="outlined"
                            value={this.state.return?(this.state.return.product.softwareVersion?this.state.return.product.softwareVersion:'N/A'):''}
                            InputProps={{
            readOnly: true,
            }}
                        />
            
                        <TextField
                            className='read-only'
                            id="outlined-search"
                            label="Production Date"
                            type="search"
                            variant="outlined"
                            value={this.state.return?moment(this.state.return.product.dateCreated).format("MMM Do YYYY"):''}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
            
                    </Col>
        
                    <Col className='column 'xs={12} lg={6}>
                    
  
                        <TextField
                            className='read-only'
                            id="outlined-search"
                            label="Ticket Opened"
                            type="search"
                            margin="normal"
                            variant="outlined"
                            value={this.state.return?moment(this.state.return.dateCreated).format("MMM Do YYYY"):''}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                        <TextField
                            className='read-only'
                            id="outlined-search"
                            label="Ticket Closed"
                            type="search"
                            margin="normal"
                            variant="outlined"
                            value={this.state.return?moment(this.state.return.dateClosed).format("MMM Do YYYY"):''}
                            InputProps={{
                                readOnly: true,
                            }}
                        /> 
                        {/* <TextField
                            className='read-only'
                            id="outlined-search"
                            label="Disposition"
                            type="search"
                            margin="normal"
                            variant="outlined"
                            value={this.state.return?this.state.return.disposition:''}
                            InputProps={{
                                        readOnly: true,
                                        }}
                        /> */}

                        {/* <TextField
                            id="outlined-search"
                            label="Estimated Hours"
                            type="search"
                            margin="normal"
                            variant="outlined"
                        />  */}
                
                    </Col>
                    <TextField
                            className ='outlined-multiline-static'
                            id="outlined-search"
                            label="Symptom Reported"
                            type="multi"
                            margin="normal"
                            variant="outlined"
                            multiline
                            rowsMax="4"
                            value={this.state.return?this.state.return.symptomReported:''}
                            InputProps={{
                                        readOnly: true,
                                        }}
                        />
                </Row>

                <Row className='bottom-row'>
                    <Col xs={12} md={6} lg={4}>
                    <div>Failure:</div>
                        <FormControl >
                           
                            
                            <Select
                                error ={this.state.failure.id === '' && !this.state.valid}
                                value={this.state.failure.id}
                                onChange={(e) => this.handleChangeFailure(e)}
                                displayEmpty
                            >
                                <MenuItem value="" disabled>
                                                    --Please Select--
                                </MenuItem>
                                {this.displayFailuresList()}
                            </Select>
                        </FormControl>
                    </Col>
                    
                    <Col xs={12} md={6} lg={4}>
                    <div>Diagnosis:</div>
                        <FormControl >
                        
                            <Select
                                error ={this.state.diagnosis.id === '' && !this.state.valid}
                                value={this.state.diagnosis.id}
                                onChange={(e) => this.handleChangeDiagnosis(e)}
                                displayEmpty
                            >
                                <MenuItem value="" disabled>
                                                    --Please Select--
                                </MenuItem>
                                {this.displayDiagnosisList()}
                            </Select>
                        </FormControl>
                    </Col>

                    <Col xs={12} md={6} lg={4}>
                   
                        {/* <FormControl >
                            <InputLabel htmlFor="detail">Detail</InputLabel>
                            <Select
                                value={this.state.detail}
                                onChange={(e) => this.handleChangeDetail(e)}
                            >
                                <MenuItem value={1}> Non determined</MenuItem>
                                <MenuItem value={2}> R1 </MenuItem>
                                <MenuItem value={3}> R2 </MenuItem>
                                <MenuItem value={4}> D2</MenuItem>
                                <MenuItem value={5}> U2</MenuItem>
                                <MenuItem value={6}> U3 </MenuItem>
                            </Select>
                        </FormControl> */}
                    </Col>
                </Row>
                <Row className='file-button'>
                </Row>
                <Row className='file-modal'>
                <Col xs={12} md={12} lg={6}>

                            <input type="file" name="file" className="inputfile" id="raised-button-file" onChange={this.onFileSelectHandler}/>
                            {this.createButton()}


                </Col>
                </Row>
                <Row> 
                <div className="table">
                    <div className="table-header" >
                    <table >
                        <thead>
                            <tr>
                                <th>File Name</th><th>Date Created</th><th>Remove</th>
                            </tr>
                        </thead>
                    </table>
                    </div>
                    <div className="table-body">   
                    <table >
                        <tbody>
                            {this.displayFiles()}
                        </tbody>
                    </table>
                    </div>    
                </div>
                </Row>
                <Row className='button-row'>
                    <Col>
                        <Button className='close-button' onClick={()=> this.closeTicketHandler() }> Close Ticket <CloseIcon/></Button>
                    </Col>
                </Row>
            </Container>
            <Row className='extra-space'></Row>
        </Container>;
    }
// Search Return by SN  BEGIN
    handleChangeSN(event){
        this.setState({sn: event.target.value});
    }

    keyPress(e){
        if(e.keyCode === 13){
            //On Enter
           // put the login here
           this.getProductByUserProductId(e.target.value);
        }
     }

    getProductByUserProductId(userProductId) {
        this.returnsSrv.getByUserProductId(userProductId)
        .then((res) => {
            return res.json()
        }
    ) 
    .then((result) => {
        if(result){
            this.setState({
                isProductsLoaded: true,
                return: result[0],
                snerror:result[0]? false:true,
                //productType: result[0].product.productType.name
            }, ()=>{this.loadDropDowns()});
        }
    },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
            console.error(error);
            this.setState({
                isProductsLoaded: true,
                error: error,
                return: null,
            });
        }
    ).catch(function(reason) { // this context is not passed into the function
        this.setState({
            isProductsLoaded: true,
            error: reason,
            return: null
        });
     });
    }
// Search Return by SN  END

// Drop Downs Begin
loadDropDowns(){
        if(this.state.return && this.state.return.product){
            this.getDiagnosisList();
            this.getFailuresList();
            this.getAllFiles();
        
        if(this.state.return.failureSymptom){
            this.setState(prevState => ({
                failure: {                   // object that we want to update
                    ...prevState.failure,    // keep all other key-value pairs
                    id: this.state.return.failureSymptom.id,
                    name:this.state.return.failureSymptom.name       // update the value of specific key
                }
            }))
        }
        if(this.state.return.diagnosis){
            this.setState(prevState => ({
                diagnosis: {                   // object that we want to update
                    ...prevState.diagnosis,    // keep all other key-value pairs
                    id: this.state.return.diagnosis.id,
                    name:this.state.return.diagnosis.name       // update the value of specific key
                }
            }))
        }
    }
}
    displayDiagnosisList(){
        if (this.state.diagnosisList){
            return this.state.diagnosisList.map(( diagnosis) => {  return <MenuItem key={diagnosis.id} value={diagnosis.id}> {diagnosis.name} </MenuItem>})
        }
    }

    displayFailuresList(){
        if (this.state.failuresList){
            return this.state.failuresList.map(( failure) => {  return <MenuItem key={failure.id} value={failure.id} name={failure.name}> {failure.name} </MenuItem>})
        }
    }

    handleChangeFailure(event){
        var failure = this.state.failuresList.find( function(failure){
            return failure.id === event.target.value;
        })
        this.setState(prevState => ({
           failure: {                   // object that we want to update
               ...prevState.failure,    // keep all other key-value pairs
               id: failure.id,
               name: failure.name       // update the value of specific key
           }
       }))

       
   }

   handleChangeDiagnosis(event){
        var diagnosis = this.state.diagnosisList.find( function(diagnosis){
           return diagnosis.id === event.target.value;
       })
       this.setState(prevState => ({
          diagnosis: {                   // object that we want to update
              ...prevState.diagnosis,    // keep all other key-value pairs
              id: diagnosis.id,
              name: diagnosis.name       // update the value of specific key
          }
      }))
   }
   getDiagnosisList(){
    this.returnsSrv.getDiagnosisByProductType(this.state.return.product.productType.id)
        .then((res) => {
                return res.json()
            }
        ) 
        .then((result) => {
            if(result){
                this.setState({
                    isDiagnosisLoaded: true,
                    diagnosisList: result,
                });
            }
        },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
                console.error(error);
                this.setState({
                    isDiagnosisLoaded: true,
                    error: error,
                    diagnosisList: null,
                });
            }
        ).catch(function(reason) { // this context is not passed into the function
            this.setState({
                isDiagnosisLoaded: true,
                error: reason,
                diagnosisList: null
            });
         });
    
    }   

    getFailuresList(){
        this.returnsSrv.getFailuresByProductType(this.state.return.product.productType.id)
            .then((res) => {
                    return res.json()
                }
            ) 
            .then((result) => {
                if(result){
                    this.setState({
                        isDiagnosisLoaded: true,
                        failuresList: result,
                    });
                }
            },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    console.error(error);
                    this.setState({
                        isDiagnosisLoaded: true,
                        error: error,
                        failuresList: null,
                    });
                }
            ).catch(function(reason) { // this context is not passed into the function
                this.setState({
                    isDiagnosisLoaded: true,
                    error: reason,
                    failuresList: null
                });
            });
        
    }   
// Drop Downs End


//Files Begin
    createButton(){
        if(!this.state.selectedFile){
            return(
                <label htmlFor="raised-button-file">
                    <Button className={ "select-file"} component="span" >
                    <strong> Attach File(s) <AttachmentIcon/></strong>
                    </Button>
                </label> )
        }
        else{
            return(
                <Button className="select-file selected" component="span" onClick={this.onFileUploadClickHandler}>
                <strong>  Upload {this.state.selectedFile.name} <UploadIcon / ></strong>
                </Button>
            )
        }
    }
    onFileSelectHandler = event =>{
        this.setState({
        selectedFile: event.target.files[0],
        loaded: 0,
        })
        // Need this here to Reset Value of file upload input
        // If not, you can't upload the same file consecutively
        event.target.value = null;
    }

    onFileUploadClickHandler = () => {
        this.addFile(this.state.selectedFile);
    }

    displayFiles(){  
        if (this.state.files && this.state.files.length > 0){
                return this.state.files.map((file) => {
                        return <tr key={file.id}>
                                        <td>{file.filename}</td>
                                        <td>{moment(file.dateCreated).format("MMM Do YYYY")}</td>
                                        <td className='deletebutton' ><CancelIcon className="remove" onClick={()=> this.deleteFile(file.id) }/></td>
                               </tr>
                })
            }
        else{
            return (<tr><td>No Files Attached</td></tr>)
        }
    }

    addFile(file){
        console.log('adding file...');
        this.returnsSrv.addFile(this.state.return.id, file)
        .then((res) => {
            return res.json()
        }
    ) 
    .then((result) => {
        if(result){
            console.log(result);
            //Reset File Selection Button
            this.setState( {selectedFile:null});
            this.getAllFiles();
        }
    },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
            console.error(error);
            this.setState({
                error:error,
                selectedFile:null
            });

        }
    ).catch(function(reason) { // this context is not passed into the function
        this.setState({
            error:reason,
            selectedFile:null
        });
     });
    }

    deleteFile(fileId){
        console.log('delete file...');
        this.returnsSrv.deleteFile(this.state.return.id, fileId)
        .then((res) => {
            if (res.ok){
                console.log(res);
                this.getAllFiles();
            }
        }
    ) 
    .then((result) => {
        if(result){
            console.log(result);
            this.getAllFiles();
            //Reset File Selection Button
            // this.setState( {selectedFile:null});
        }
    },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
            console.error(error);
            this.setState({
                error:error,
                // selectedFile:null
            });

        }
    ).catch(function(reason) { // this context is not passed into the function
        this.setState({
            error:reason,
            // selectedFile:null
        });
     });
    }

    getAllFiles(){
        this.returnsSrv.getAllFiles(this.state.return.id)
        .then((res) => {
                return res.json()
            }
        ) 
        .then((result) => {
            if(result){
                this.setState({files: result});
            }
        },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
                console.error(error);
                this.setState({
                    error:error,
                    files:null
                });

            }
        ).catch(function(reason) { // this context is not passed into the function
            this.setState({
                error:reason,
                files:null
            });
         });
    }
//Files END

//Close Ticket BEGIN
    closeTicketHandler(){
        if (this.checkValid()){
            this.setState(prevState => ({
                return: {                   // object that we want to update
                    ...prevState.return,    // keep all other key-value pairs
                    failureSymptom: this.state.failure ,
                    diagnosis: this.state.diagnosis      // update the value of specific key
                }
            }), ()=>{
                this.returnsSrv.updateReturn(this.state.return).then((res) => {
                    if (res.ok){
                        console.log(res);
                        window.location.reload();
                    }
                });
            })
        }
        else{
            // Add Message"One or More required fields is Incomplete"
            console.log('not valid');
        }
    }

    checkValid(){
        
        if (this.state.failure.id !== '' && this.state.diagnosis.id !==''){
            this.setState({valid: true});
            return true;
        } else{
            this.setState({valid: false});
            return false;
           
        }
    }
//Close Ticket End
  
}
    Returns.propTypes = {
        auth: PropTypes.object
    };

export default Returns;